module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_8023.e9889133.png";